import { useEffect, useState } from "react";

import Player from "@vimeo/player";

import { Video } from "vimeo";

interface Props {
    video: Video;
}

export function VimeoPlayer(props: Props) {
    const { video } = props;
    const [playerNode, setPlayerNode] = useState<HTMLDivElement>();
    const [playerUrl, setPlayerUrl] = useState("");

    useEffect(() => {
        if (!playerNode) {
            return;
        }

        // If the URL is the same, we need to trigger a reload of the iframe.
        if (playerUrl === video.player_embed_url) {
            const iframeEl = playerNode.querySelector("iframe");
            if (!iframeEl) {
                return;
            }

            // But we can't access the iframe content window across iframe boundaries
            // due to cross-origin security violations.
            // So, unload the video and load it again.
            var player = new Player(iframeEl);
            player.unload().then(() => {
                player.loadVideo(video.player_embed_url);
            });
            return;
        }

        setPlayerUrl(video.player_embed_url);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [video, playerNode]);

    return (
        <div
            className="slds-align_absolute-center"
            ref={(node) => setPlayerNode(node!)}
        >
            <iframe
                title={video.name}
                src={playerUrl}
                style={{ width: "600px", minHeight: "400px" }}
                frameBorder={0}
                allowFullScreen={true}
            ></iframe>
        </div>
    );
}
